
import { Injectable, Output, EventEmitter } from "@angular/core";
import { DropDownOption } from '../entities/dropdown/dropDown-options'
import provinceList from '../entities/provinceList.json'
import { Emplooyee } from '../entities/employee';

@Injectable()

export class CommonDropdownService {

    private _EmplooyeeList: Emplooyee[] = [];
    private _EmplooyeeListDropDown: DropDownOption[] = [];
    private  _provinceArray : any[]=[];


    @Output() ProvinceDropDownData: EventEmitter<any> = new EventEmitter<any>();
    constructor() {

     }

    ProvinceList() {
                this._EmplooyeeList = [];
                this._EmplooyeeList = provinceList;
           
                 this.LoadRoomStatusListDropDown(this._EmplooyeeList)
    }

    private LoadRoomStatusListDropDown(list): void {
        if (list) {
            this._EmplooyeeListDropDown = [];
            this._EmplooyeeListDropDown.push(new DropDownOption("0", "-- seleccionar --", false));

            list.forEach((element) => {
                let option = new DropDownOption(element._id.toString(), element.option, false);
                this._EmplooyeeListDropDown.push(option);

                 
                
            });
            this.emitData(this._EmplooyeeListDropDown)
        }
        

    }

    emitData(data : any){
        this.ProvinceDropDownData.emit(data);
    }

}
